module.exports = __webpack_public_path__ + "img/projector.3489db1b.jpg";